/**
 * Utilization dashboard inside the super admin console.
 *
 * Same component the portal admin console mounts at /admin/utilization/*, wired
 * to the super admin's API client. See SuperAdminFinance for why the scope
 * difference lives on the server rather than in a prop here.
 *
 * `segment` is passed through so the Buyers and BL Advisors routes are the same
 * page reporting on a different audience.
 */
import UtilizationDashboardPage, { type Segment } from "@/pages/UtilizationDashboard";

import { superAdminApi } from "./session";

export default function SuperAdminUtilizationPage({ segment }: { segment: Segment }) {
  return <UtilizationDashboardPage client={superAdminApi} segment={segment} />;
}
